/*============================================================================
  Anniversary set module: state logic (pure, DOM-free).

  Rule (Kilian, 2026-09-26/27): at least one of each of the three configured
  anniversary pieces, any size, earns the Perplex Anniversary Magazine. The
  gift itself is added post-checkout by Shopify Flow; this module only shows
  the progress, so it counts DISTINCT products held, never units - three of
  the same tee is 1 of 3 here exactly as it is in the Flow condition.

  The three pieces come from theme settings (anniv_set_product_1..3, rendered
  into #AnnivSetConfig by snippets/cart-anniv-set-config.liquid). A blank or
  unpublished product setting renders no entry, and an incomplete config
  disables the module instead of promising a Magazine for a two-piece "set".

  No Shopify/DOM dependency, so it runs under Node for tests
  (test/cart-anniv-set-logic.test.js).
============================================================================*/
(function(root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.theme = root.theme || {};
    root.theme.AnnivSetLogic = factory();
  }
}(typeof self !== 'undefined' ? self : this, function() {

  var EXPECTED_PIECES = 3;

  // cart.js product_id values are numbers; Liquid `| json` ids are numbers
  // too, but compare as strings so a config or cart shape change can't
  // silently turn a match into a miss.
  function idKey(id) {
    return id === null || id === undefined ? '' : String(id);
  }

  function computeSetState(cartItems, setProducts) {
    var products = setProducts || [];
    var base = {
      active: false,
      reason: null,
      heldCount: 0,
      total: EXPECTED_PIECES,
      complete: false,
      missing: [],
      segments: []
    };

    if (products.length !== EXPECTED_PIECES) {
      base.reason = 'incomplete_config';
      return base;
    }

    var heldIds = {};
    (cartItems || []).forEach(function(item) {
      if (!item || !(item.quantity > 0)) return;
      heldIds[idKey(item.product_id)] = true;
    });

    var segments = products.map(function(product) {
      return !!heldIds[idKey(product.id)];
    });
    var heldCount = segments.filter(Boolean).length;
    var missing = products.filter(function(product, i) {
      return !segments[i];
    });

    return {
      active: heldCount > 0,
      reason: heldCount > 0 ? null : 'no_pieces',
      heldCount: heldCount,
      total: EXPECTED_PIECES,
      complete: heldCount === EXPECTED_PIECES,
      missing: missing,
      segments: segments
    };
  }

  // Locale key suffix for the module's message line. Sold out (the
  // anniv_magazine_sold_out setting) replaces the Magazine promise in every
  // state, including 3 of 3, so a flipped setting never leaves a stale "Free"
  // confirmation on screen.
  function messageKey(state, soldOut) {
    if (soldOut) return 'sold_out';
    if (state.complete) return 'complete';
    return state.heldCount >= EXPECTED_PIECES - 1 ? 'progress_two' : 'progress_one';
  }

  // Generic upsell rail (theme.CartUpsell) must not repeat a piece the set
  // module is already offering.
  function excludeSetProducts(recommendations, setProducts) {
    if (!setProducts || !setProducts.length) return recommendations || [];
    var handles = setProducts.map(function(p) { return p.handle; });
    return (recommendations || []).filter(function(rec) {
      return !rec || handles.indexOf(rec.handle) === -1;
    });
  }

  return {
    EXPECTED_PIECES: EXPECTED_PIECES,
    computeSetState: computeSetState,
    messageKey: messageKey,
    excludeSetProducts: excludeSetProducts
  };
}));
